<ng-container *ngIf="aRoute.children.length === 0">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header nzBackIcon [nzGhost]="false">
      <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
    </nz-page-header>
  </nz-affix>

  <nz-tabset nzLinkRouter>
    <nz-tab>
      <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tab: 'main' }" queryParamsHandling="merge">
        {{ 'tab.main' | transloco }}
      </a>
      <hc-product-definition-edit [model]="model" [isCreate]="isCreate" [isEdit]="isEdit"></hc-product-definition-edit>
    </nz-tab>
    <nz-tab *ngIf="isEdit">
      <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tab: 'split' }" queryParamsHandling="merge">
        {{ 'tab.split' | transloco }}
      </a>
      <hc-product-def-split-list [productInfoId]="model.id"></hc-product-def-split-list>
    </nz-tab>
    <nz-tab *ngIf="isEdit">
      <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tab: 'media' }" queryParamsHandling="merge">
        {{ 'tab.media' | transloco }}
      </a>
      <!-- lazy: the photos are read, and the poll starts, only when the tab is opened -->
      <ng-template nz-tab>
        <hc-product-media [productInfoId]="model.id"></hc-product-media>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</ng-container>

<router-outlet></router-outlet>
